export const findOrganizationIndex = (access) => {
  if (access) {
    const organizationIndex = access.findIndex(
      (menu) => menu?.key_name === "Organization"
    );
    return organizationIndex;
  }
  return -1;
};

export const getViewStatus = (userInfo, topMenuIndex, subMenuIndex) => {
  //console.log(userInfo);
  if (userInfo && userInfo.data.access) {
    try {
      const organizationIndex = findOrganizationIndex(userInfo?.data?.access);
      const topMenu =
        userInfo?.data?.access[organizationIndex].side_menu[0].top_menu[
          topMenuIndex
        ];
      const submenu = topMenu.sub_menu[subMenuIndex];
      const hasTrueAccess = submenu.role_access.some(
        (role) => role.view === true
      );
      return hasTrueAccess;
    } catch (error) {
      return false;
    }
  }
  return false;
};

export const getUpdateStatus = (userInfo, topMenuIndex, subMenuIndex) => {
  //console.log(userInfo);
  if (userInfo && userInfo.data.access) {
    try {
      const organizationIndex = findOrganizationIndex(userInfo?.data?.access);
      const topMenu =
        userInfo?.data?.access[organizationIndex].side_menu[0].top_menu[
          topMenuIndex
        ];
      const submenu = topMenu.sub_menu[subMenuIndex];
      const hasTrueAccess = submenu.role_access.some(
        (role) => role.update === true
      );
      return hasTrueAccess;
    } catch (error) {
      return false;
    }
  }
  return false;
};

export const getSubMenuName = (userInfo, topMenuIndex, subMenuIndex) => {
  //console.log(userInfo);
  if (userInfo && userInfo?.data?.access) {
    try {
      const organizationIndex = findOrganizationIndex(userInfo?.data?.access);

      const topMenu =
        userInfo?.data?.access[organizationIndex].side_menu[0].top_menu[
          topMenuIndex
        ];
      const submenu = topMenu.sub_menu[subMenuIndex]?.name;
      return submenu;
    } catch (error) {
      //console.log("Error retrieving view status:", error);
      return "";
    }
  }
  return "";
};

export const getMainMenuName = (userInfo, topMenuIndex) => {
  //console.log(userInfo);
  if (userInfo && userInfo?.data?.access) {
    try {
      const organizationIndex = findOrganizationIndex(userInfo?.data?.access);

      const topMenuName =
        userInfo?.data?.access[organizationIndex].side_menu[0].top_menu[
          topMenuIndex
        ]?.name;

      return topMenuName;
    } catch (error) {
      //console.log("Error retrieving view status:", error);
      return "";
    }
  }
  return "";
};

export const getAtleastOneBlue = (userInfo, topMenuIndex) => {
  if (userInfo && userInfo.data.access) {
    try {
      const organizationIndex = findOrganizationIndex(userInfo?.data?.access);
      const topMenu =
        userInfo?.data?.access[organizationIndex].side_menu[0].top_menu[
          topMenuIndex
        ];
      const hasTrueAccess = topMenu.sub_menu.some((submenu) =>
        submenu.role_access.some((role) => role.view === true)
      );

      return hasTrueAccess;
    } catch (error) {
      return false;
    }
  }
  return false;
};

// Function to find the index of the "Settings" menu in the access array

export const findSettingIndex = (access) => {
  if (access) {
    const settingIndex = access.findIndex(
      (menu) =>
        menu?.key_name === "LMS Beta" || menu?.key_name === "TraineryLearn"
    );
    return settingIndex;
  }
  return -1;
};
export const findBetaIndex = (access) => {
  if (access) {
    const settingIndex = access.findIndex(
      (menu) =>
        menu?.key_name === "LMS Beta" || menu?.key_name === "TraineryLearn"
    );
    return settingIndex;
  }
  return -1;
};

export const getSettingViewStatus = (
  userInfo,
  topMenuIndex,
  otherIndex,
  subMenuIndex
) => {
  //console.log(userInfo);
  if (userInfo && userInfo.data.access) {
    try {
      const organizationIndex = findSettingIndex(userInfo?.data?.access);
      const topMenu =
        userInfo?.data?.access[organizationIndex].side_menu[otherIndex]
          .top_menu[topMenuIndex];
      const submenu = topMenu.sub_menu[subMenuIndex];
      const hasTrueAccess = submenu.role_access.some(
        (role) => role.view === true
      );
      return hasTrueAccess;
    } catch (error) {
      return false;
    }
  }
  return false;
};
